// frontend/src/lib/contractDeleteError.js
// C4/P6b: DELETE /api/contracts/:id now refuses with 409 { error, code: 'money_guard' }
// when the contract carries invoices or terminations. The operator must SEE why.
// NB: api/client.js flattens errors — the rejected value carries `err.data`
// and has NO `err.response`, so `err?.response?.data?.error` never resolves.
export const CONTRACT_DELETE_FALLBACK = 'Не удалось удалить договор';

export function contractDeleteErrorMessage(err) {
  return err?.data?.error || err?.message || CONTRACT_DELETE_FALLBACK;
}
